import { render, staticRenderFns } from "./DashboardLayout2.vue?vue&type=template&id=b6d4e698"
import script from "./DashboardLayout2.vue?vue&type=script&lang=js"
export * from "./DashboardLayout2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports